export const Gear: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10.667 2.5c.352 0 .666.22.784.552l.424 1.179a.84.84 0 0 0 .368.44l1.256.725c.17.098.37.133.564.098l1.233-.222a.83.83 0 0 1 .871.403l.667 1.15a.83.83 0 0 1-.083.955l-.81.957a.83.83 0 0 0-.197.538v1.45c0 .197.07.388.197.538l.81.957c.226.269.26.65.083.955l-.667 1.15a.83.83 0 0 1-.87.403l-1.233-.222a.83.83 0 0 0-.564.098l-1.256.725a.84.84 0 0 0-.368.44l-.424 1.18a.83.83 0 0 1-.785.551H9.334a.83.83 0 0 1-.784-.552l-.424-1.179a.84.84 0 0 0-.367-.44l-1.257-.725a.83.83 0 0 0-.564-.098l-1.233.222a.83.83 0 0 1-.871-.403l-.667-1.15a.83.83 0 0 1 .084-.955l.809-.957a.83.83 0 0 0 .197-.538v-1.45a.83.83 0 0 0-.197-.538l-.801-.957a.83.83 0 0 1-.083-.955l.666-1.15a.83.83 0 0 1 .87-.403l1.234.222c.193.035.393 0 .564-.098l1.256-.725c.17-.1.3-.255.368-.44l.423-1.18a.83.83 0 0 1 .777-.551z"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10 12.292a2.292 2.292 0 1 0 0-4.584 2.292 2.292 0 0 0 0 4.584"
    ></path>
  </svg>
);
